module.exports = __webpack_public_path__ + "static/media/linked-in.9d840f2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linked-in.svg
// module id = 1991
// module chunks = 0